import React from "react";

const MobileDeleteButton = props => {
  return (
    <button
      // className="btn btn-warning btn-lg"
      className="btn btn-danger btn-lg"
      value={"delete"}
      onClick={() => {
        props.onClick();
      }}
    >
      {props.title.text}
    </button>
  );
};

export default MobileDeleteButton;
